var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('PageIntro',{attrs:{"heading":'Your <span>My Stoke</span> account',"body":'<p>You must set a new password.</p>'}}),_c('SetNewPasswordForm'),_c('FooterShout',{attrs:{"type":'signin'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }